export default __webpack_public_path__ + "static/media/imagination.1f74f06f.webp";